
  /* a utiliser en prod */
  export const api =  {'url' : 'api'};

  /* a utiliser en dev */
  //export const api =  {'url' : 'rest/api'};


